import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';

import { PopulateAnalytics } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { RecentListItem } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { GenericAction, SelectedData, Tab } from '@com-delta-omnichannel/mach';
import {
  BookWidgetFieldInfoTypes,
  BookWidgetFieldUpdateTypes
} from '../../constants/book-widget.constants';
import { BookWidgetAem } from '../../models/book-widget-aem.interfaces';
import { BookWidgetFieldUpdateEvent } from '../../models/book-widget-fields-update-info.interfaces';
import { BookWidgetFields } from '../../models/book-widget-fields.interfaces';
import { DatepickerConfig } from '../../models/common.interfaces';
import {
  SearchModalEvent,
  SearchModalEventType
} from '../../models/search-modal-events-object.interface';
import { InfoPopUpModalComponent } from '../common/info-popup-modal/info-popup-modal.component';
import { InfoPopUpContent } from '../common/info-popup-modal/models/info-popup-modal.interface';
import { HomeBookWidgetExtendedComponent } from './home-book-widget.extended';
import { HomeBookWidgetImports } from './home-book-widget.imports';
@Component({
  standalone: true,
  selector: 'idp-home-book-widget',
  templateUrl: './home-book-widget.component.html',
  styleUrls: ['./home-book-widget.component.scss'],
  imports: HomeBookWidgetImports
})
export class HomeBookingWidgetComponent
  extends HomeBookWidgetExtendedComponent
  implements OnChanges
{
  @Input() isDesktop = false;
  @Input() bookWidgetFields?: BookWidgetFields;
  @Input() override bookWidgetAem?: BookWidgetAem | null;
  @Input() searchModalTabs: Tab[] = [];
  @Input() recentSearchList: RecentListItem[] = [];
  @Input() savedSearchList: string[] = [];
  @Input() datepickerConfig: DatepickerConfig = {} as DatepickerConfig;
  //can only be list of predictive items
  @Input() set predictiveSearchList(list: GenericAction[]) {
    this.predictiveSearchData = {
      ...this.predictiveSearchData,
      items: list || ([] as GenericAction[])
    };
  }

  @Input() guidedNavigationErrorMsg?: string | null = null;
  @Output() analyticsEvent = new EventEmitter<PopulateAnalytics>();
  setAdvancedSearchExpandedStatus() {
    if (
      this.bookWidgetFields?.meetingEventCodeField.fieldErrorInfo?.errorMessage
    ) {
      this.isAdvancedSearchExpanded = true;
    }
  }

  @Input() viewSearchOptionExpanded = false;
  @Output() bookWidgetFieldChange =
    new EventEmitter<BookWidgetFieldUpdateEvent>();

  @Output() findFlight = new EventEmitter();
  @Output() swapAirports = new EventEmitter<number>();
  @Output() addFlightsForMc = new EventEmitter();
  @Output() removeFlightForMc = new EventEmitter();
  @Output() searchModalEvent = new EventEmitter<
    SearchModalEvent<SearchModalEventType>
  >();

  @Output() routePickerClicked = new EventEmitter<SelectedData>();
  @Output() override viewSearchOptionEvent = new EventEmitter();
  @ViewChild('infoPopUpModal') infoPopUpModal!: InfoPopUpModalComponent;

  constructor(private elementRef: ElementRef) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['guidedNavigationErrorMsg'] && this.guidedNavigationErrorMsg) {
      this.setAdvancedSearchExpandedStatus();
    }
  }

  infoIconClickHandler(event: BookWidgetFieldInfoTypes) {
    this.infoPopUpModalData = this.getToolTipContent(event);
    this.showDialog = true;
  }

  getToolTipContent(event: BookWidgetFieldInfoTypes): InfoPopUpContent {
    if (this.bookWidgetAem) {
      this.infoPopUpModalData.title =
        this.bookWidgetAem[event]?.infoModal.title || '';
      this.infoPopUpModalData.description =
        this.bookWidgetAem[event]?.infoModal.description || '';
      return this.infoPopUpModalData;
    } else {
      return this.infoPopUpModalData;
    }
  }

  closeModal() {
    this.showDialog = false;
  }

  bookWidgetFieldChangeHandler(event: BookWidgetFieldUpdateEvent) {
    this.bookWidgetFieldChange.emit(event);
    if (event.type === BookWidgetFieldUpdateTypes.tripType) {
      setTimeout(() => {
        const element =
          this.elementRef.nativeElement.querySelector('#trip-type-field');
        element?.focus();
      });
    }
  }

  handleModalTriggerClicked(event: SelectedData) {
    this.predictiveSearchData = {
      ...this.predictiveSearchData,
      placeholder: this.preparePlaceholderText(event.type),
      value: event.selectedResult.cityCode,
      errorMessage: this.bookWidgetAem?.errorMessages['SBW015'].message,
      selectLabel: this.bookWidgetAem?.airportsField.searchModal.selectLabel
    };
  }

  toggleAdvSearchExpanded() {
    this.isAdvancedSearchExpanded = !this.isAdvancedSearchExpanded;
  }

  findFlightClickHandler() {
    this.findFlight.emit();
  }
}
